import { render } from "./GradeV2Tasks.vue?vue&type=template&id=206fb52b&scoped=true&ts=true&lang=pug"
import script from "./GradeV2Tasks.vue?vue&type=script&lang=ts"
export * from "./GradeV2Tasks.vue?vue&type=script&lang=ts"

import "./GradeV2Tasks.vue?vue&type=style&index=0&id=206fb52b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206fb52b"]])

export default __exports__